function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 8.202V13.378H13.9993V8.54867C13.9993 7.33533 13.5653 6.50733 12.4793 6.50733C11.65 6.50733 11.1567 7.06533 10.9393 7.60533C10.8607 7.79867 10.84 8.06667 10.84 8.33667V13.378H7.83867C7.83867 13.378 7.87867 5.19867 7.83867 4.35133H10.84V5.63067L10.82 5.66H10.84V5.63067C11.2387 5.01667 11.9507 4.13933 13.5447 4.13933C15.5193 4.13933 17 5.42933 17 8.202ZM4.69867 0C3.672 0 3 0.673333 3 1.55933C3 2.426 3.652 3.11933 4.65867 3.11933H4.67867C5.72533 3.11933 6.37667 2.426 6.37667 1.55933C6.35667 0.673333 5.72533 0 4.69867 0ZM3.17867 13.378H6.17867V4.35133H3.17867V13.378Z",
  fill: "white"
});

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.faa839ad.svg";
export { ForwardRef as ReactComponent };